// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-futurebuilders-js": () => import("./../src/pages/futurebuilders.js" /* webpackChunkName: "component---src-pages-futurebuilders-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-wanted-js": () => import("./../src/pages/wanted.js" /* webpackChunkName: "component---src-pages-wanted-js" */)
}

